export const zh = {
  title: '风速潜力',
  subtitle: '1 公里分辨率，全球，DTU/世界银行集团/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: '功能',
      value: '全球任意地点的平均风速',
    },
    {
      label: '分辨率',
      value: '1 公里',
    },
    {
      label: '地理覆盖范围',
      value: '全球',
    },
    {
      label: '来源',
      value: 'DTU/Kelompok Bank Dunia/ESMAP',
    },
    {
      label: '更新频率',
      value: '',
    },
    {
      label: '内容日期',
      value: '',
    },
    {
      label: '注意事项',
      value:
        '全球风能图（GWA）采用两个主要的建模组件，这些组件可能会在计算过程中引入不确定性。这两个组件分别是: 中尺度建模（Mesoscale modeling), 微尺度建模（Microscale modeling）',
    },
    {
      label: '许可证',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: '概览',
    value:
      '全球风能图（GWA）平均风速数据集由丹麦技术大学（DTU）风能系、世界银行集团 和 能源部门管理援助计划（ESMAP） 共同生成。\n\n平均风速是风能发电的关键性能指标之一。GWA 采用低分辨率风速数据，并通过降尺度处理转换为高分辨率数据。这一过程的结果是一个全球范围（不包括南北极及远海区域）的局部风气候模型，提供1 公里分辨率的风速数据，涵盖50 米、100 米和 200 米三个高度。',
  },
  citation: {
    label: '引用',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
